// extracted by mini-css-extract-plugin
module.exports = {"authWrapper":"PrivateRoute_authWrapper__0P76s"};